<template>
    <div
        :id="id"
        class="lni-u-mt2"
    >
        <h2 class="lni-u-heading--2 lni-u-mb2">
            {{ getData('complaint.heading') }}
        </h2>
        <lni-checkbox-list
            :id="`${id}_complaint`"
            :required="true"
        />
        <div class="lni-u-reading-width--max">
            <lni-input-textarea
                :id="`${id}_complaint-description`"
                class="lni-u-mb2"
                :fullWidth="true"
                :limit="2000"
                :required="true"
            />
        </div>
        <fieldset class="lni-u-mb2">
            <legend class="lni-u-type--bold">
                {{ getData('complaint.dateRange') }}
            </legend>
            <div class="lni-u-flex lni-u-flex-wrap lni-u-full-width">
                <lni-input-date
                    :id="`${id}_start-date`"
                    class="lni-u-pr3"
                    :changeAction="`${id}/checkComplaintDuration`"
                    :customValidityAction="`${id}/complaintDurationCustomValidation`"
                    :isFieldset="false"
                    helperText=""
                />
                <lni-input-date
                    :id="`${id}_end-date`"
                    :changeAction="`${id}/checkComplaintDuration`"
                    :isFieldset="false"
                    helperText=""
                />
            </div>
        </fieldset>
        <div class="lni-u-reading-width--max">
            <lni-input-textarea
                :id="`${id}_description`"
                class="lni-u-mb1"
                :fullWidth="true"
                :limit="2000"
                :required="false"
            >
                <span slot="helperText">{{ getData('complaint.description.helper') }}</span>
            </lni-input-textarea>
            <lni-input-textarea
                :id="`${id}_outcome`"
                class="lni-u-mb2"
                :fullWidth="true"
                :limit="2000"
                :required="false"
            >
                <span slot="helperText">{{ getData('complaint.outcome.helper') }}</span>
            </lni-input-textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LniRetaliationComplaints',
    mounted() {
        this.addCustomValidityTests();
    },
    methods: {
        addCustomValidityTests() {
                this.$store.commit(`${this.id}_start-date/addValidityTest`, {
                    validityTest: 'invalidDuration',
                    global: () =>
                        `Complaint Duration start date cannot be after end date.`,
                    inline: () =>
                        `Start date cannot be after end date.`,
                }, {
                    root: true,
                });
        },
        getData(name) {
            return this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
        },
    },
};
</script>